import {useCallback} from 'react'

import {useEnabledFeatures} from '../../hooks/use-enabled-features'
import {usePaginatedMemexItemsQuery} from '../memex-items/queries/use-paginated-memex-items-query'

export const useHandlePaginatedDataRefresh = () => {
  const {memex_table_without_limits} = useEnabledFeatures()
  const {invalidateAllQueries} = usePaginatedMemexItemsQuery()

  const handleUpdateData = useCallback(async () => {
    if (memex_table_without_limits) {
      return invalidateAllQueries()
    }
  }, [memex_table_without_limits, invalidateAllQueries])

  return handleUpdateData
}
